import React from "react";
import { FaLinkedin, FaTwitter, FaInstagram, FaYoutube } from "react-icons/fa";
import { MdEmail, MdPhone, MdLocationOn } from "react-icons/md";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer" id="footer">
      <div className="footer-top">
        {/* Brand */}
        <div className="footer-brand">
          <img src="img/pixelcut-export.png" alt="WASME" className="footer-logo" />
          <p className="footer-description">
            At New Life Research, we are committed to creating high-performance
            housekeeping and hygiene products rooted in scientific research and
            safe ingredients.
          </p>
          <div className="social-links">
            <a href="#"><FaLinkedin /></a>
            <a href="#"><FaTwitter /></a>
            <a href="#"><FaInstagram /></a>
            <a href="#"><FaYoutube /></a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-links">
          <h3 className="footer-heading">Quick Links</h3>
          <ul>
            <li><a href="#home">Home</a></li>
          <li><a href="#products">Products</a></li>
         <li><a href="#ingredients">Research</a></li> 
          <li><a href="#about">About Us</a></li>
            <li><a href="#contact">Contact Us</a></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-contact">
          <h3 className="footer-heading">Contact Us</h3>

          <div className="contact-item">
            <MdLocationOn className="contact-icon" />
            <p>Film City, Sector 16A, Noida, U.P.</p>
          </div>

          <div className="contact-item">
            <MdPhone className="contact-icon" />
            <p>+91-9560-685-555 <br /> +91-120-4216283</p>
          </div>

          <div className="contact-item">
            <MdEmail className="contact-icon" />
            <p>www.newliferesearch.in</p>
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} New Life Research. All Rights Reserved.</p>
        <div className="legal-links">
          <a href="#">Privacy Policy</a>
          <a href="#">Terms of Service</a>
          <a href="#">Sitemap</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
